<template>
 <Head>
    <title> Create Skill Group | {{$page.props.appName}}</title>
    <meta name="description" :content="'Create Skill Group ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
      <form @submit.prevent="store">
       

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Skill Group Name:</label>
            <input v-model="this.form.skill_group_name" type="text" class="form-input" placeholder="Skill Group Name"/>
          </div>
        </div>
        <div class="w-full">
            <button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right" :disabled="form.processing">CREATE SKILL GROUP </button>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head },
  data() {
    return {
      url: "",
      form: this.$inertia.form({
        skill_group_name: null,
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/skillgroup/create");
    },
  },
};
</script>
     